export default "__VITE_PUBLIC_ASSET__336682d9__"